import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'lg';
  className?: string;
}

export function LoadingSpinner({ size = 'sm', className = '' }: LoadingSpinnerProps) {
  return (
    <div className={`spinner ${size === 'lg' ? 'spinner-lg' : ''} ${className}`} />
  );
}

export function PageLoader() {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '200px',
      gap: '12px',
      color: 'var(--text3)',
      fontSize: '13px',
    }}>
      <LoadingSpinner size="lg" />
      <span>Laden...</span>
    </div>
  );
}
